module.exports = __webpack_public_path__ + "static/media/bariol_regular.b4346fed77712978e621deabf119c73541b5b0ccd7fdf57750da8e6de04be185.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bariol_regular.woff
// module id = 2549
// module chunks = 204